import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import './Hero.css';

function Hero() {
  const scrollToSignup = () => {
    const signupSection = document.getElementById('signup');
    if (signupSection) {
      signupSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className='hero' id='hero'>
      <div className='hero-background'>
        <div className='gradient-orb orb-1'></div>
        <div className='gradient-orb orb-2'></div>
        <div className='gradient-orb orb-3'></div>
      </div>

      <div className='hero-container'>
        <div className='hero-badge'>
          <Sparkles size={16} />
          <span>Free for early users • Limited spots</span>
        </div>

        <h1 className='hero-title'>
          Posting the same type of content{' '}
          <span className='gradient-text'>makes you forgettable.</span>
        </h1>

        <p className='hero-subtitle'>
          Get personalized ideas from <strong>trending discussions</strong>{' '}
          matched to your role, industry, and professional goals. Post across{' '}
          <strong>7 categories </strong>— insights, lessons, trends, stories to
          build a profile people actually recognize.
        </p>

        <div className='hero-insight'>
          <p className='insight-text'>
            Trending ideas + Personalization + Category rotation ={' '}
            <strong>
              <em>Stand out</em>
            </strong>
          </p>
        </div>

        <div className='hero-cta'>
          <button className='cta-primary' onClick={scrollToSignup}>
            Get my ideas — Start free
            <ArrowRight size={20} />
          </button>
        </div>

        <p className='hero-trust'>
          No credit card • First ideas in 24 hours • Start standing out this
          week
        </p>
      </div>
    </section>
  );
}

export default Hero;
